import type { SerializedWorkerError } from './types';

export const toSerializedWorkerError = (
  error: unknown
): SerializedWorkerError => {
  if (error instanceof Error) {
    return { name: error.name, message: error.message, stack: error.stack };
  }
  if (typeof error === 'string') {
    return { name: 'Error', message: error };
  }
  return { name: 'Error', message: safeStringify(error) };
};

const safeStringify = (value: unknown): string => {
  try {
    return JSON.stringify(value) ?? String(value);
  } catch {
    return String(value);
  }
};

export const fromSerializedWorkerError = ({
  name,
  message,
  stack,
}: SerializedWorkerError): Error => {
  const error = Error(message);
  error.name = name;
  if (stack) {
    error.stack = stack;
  }
  return error;
};
